import service from './glassRequest'
export function getkilnTemp() {
  return service({
    method: 'get',
    url: '/kilnTemp',
  })
}
export function getmaterialsLib() {
  return service({
    method: 'get',
    url: '/materialsLib',
  })
}
export function getfeedChannel() {
  return service({
    method: 'get',
    url: '/feedChannel',
  })
}
export function getdetest() {
  return service({
    method: 'get',
    url: '/detest',
  })
}
export function getannealing() {
  return service({
    method: 'get',
    url: '/annealing',
  })
}
export function getmaterialsWeight(id) {
  return service({
    method: 'get',
    url: `/materialsWeight/${id}`,
    // params:{
    //   id
    // }
  })
}
export function getfeedTemp(id) {
  return service({
    method: 'get',
    url: `/feedTemp/${id}`,
  })
}
export function getstoneTemp(id) {
  return service({
    method: 'get',
    url: `/stoneTemp/${id}`,
  })
}
export function getbottleWeight(id) {
  return service({
    method: 'get',
    url: `/bottleWeight/${id}`,
  })
}
export function getproductionInfo(id) {
  return service({
    method: 'get',
    url: `/productionInfo/${id}`,
  })
}
export function getworkshopTemp(id) {
  return service({
    method: 'get',
    url: `/workshopTemp/${id}`,
  })
}
export function getrelatedInfo(id) {
  return service({
    method: 'get',
    url: `/relatedInfo/${id}`,
  })
}
export function getflueTemp(id) {
  return service({
    method: 'get',
    url: `/flueTemp/${id}`,
  })
}
export function gethistogram(id) {
  return service({
    method: 'get',
    url: `/histogram/${id}`,
  })
}
export function getelectricity(id) {
  return service({
    method: 'get',
    url: `/electricity/${id}`,
  })
}
export function getmaterialUse(id) {
  return service({
    method: 'get',
    url: `/materialUse/${id}`,
  })
}


// WEBPACK FOOTER //
// ./src/network/glassScreen.js